export default "__VITE_ASSET__1vTSHdoc__"